// parent class for all classes that are being used with immer (i.e. basically put into redux store)

// TODO: completely get rid of immerable by changing all class instance objects we put into redux store
// into plain javascript objects/types instead
import { immerable } from "@reduxjs/toolkit/node_modules/immer";

export default class Immerable {
  // let's immer know that this class (or any derivates) is compatible with immer
  [immerable] = true;
}